import { e2eTestId } from "@e2e/test-ids";
import styled from "@emotion/styled";
import { row } from "@ui/style";
import { colors } from "@ui/style/colors";
import React, { SVGProps } from "react";

interface MenuRowProps {
	icon: React.FC<SVGProps<SVGElement>>;
	title: string;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const MenuRow = ({ title, icon: Icon, onClick }: MenuRowProps): JSX.Element => (
	<MenuRowContainer onClick={onClick} data-test={e2eTestId.homePage.profileMenuItem}>
		<IconContainer>
			<Icon height={20} width={20} color={colors.primary} />
		</IconContainer>
		<div className="p-size-s">{title}</div>
	</MenuRowContainer>
);

const MenuRowContainer = styled.div`
	${row(8, "flexstart", "center")}
	padding: 8px 8px 8px 16px;
	transition: background-color 0.2s;
	cursor: pointer;

	:hover {
		background-color: ${colors.primaryBackground};
	}

	:active {
		background-color: ${colors.primary10};
	}
`;

const IconContainer = styled.div`
	display: flex;
	justify-content: center;
`;
